import { useTheme } from '../../theme/ThemeProvider';
import type { ThemePreference } from '../../theme/theme-storage';

const OPTIONS: { value: ThemePreference; glyph: string; label: string }[] = [
  { value: 'system', glyph: '🖥', label: 'Follow system' },
  { value: 'light', glyph: '☀', label: 'Light' },
  { value: 'dark', glyph: '☾', label: 'Dark' },
];

/**
 * Three states, not two. ⭐ A two-way switch cannot express "go back to following the OS" once you
 * have touched it, and the requirement is explicitly "system by default, explicit toggle wins".
 */
export function ThemeToggle() {
  const { preference, setPreference } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="flex items-center gap-0.5 rounded border border-[color:var(--color-line)] p-0.5"
    >
      {OPTIONS.map((option) => {
        const active = preference === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={option.label}
            title={option.label}
            onClick={() => setPreference(option.value)}
            className={`h-7 w-8 rounded text-sm ${
              active
                ? 'bg-[color:var(--color-surface-sunken)] text-[color:var(--color-ink)]'
                : 'text-[color:var(--color-ink-muted)] hover:bg-black/5 dark:hover:bg-white/10'
            }`}
          >
            <span aria-hidden="true">{option.glyph}</span>
          </button>
        );
      })}
    </div>
  );
}
